import CityPageTemplate from "../city-template/CityPageTemplate";
import { dundalkConfig } from "./data";

export default function DundalkPage() {
  return <CityPageTemplate config={dundalkConfig} />;
}